// extracted by mini-css-extract-plugin
module.exports = {"thumbnailImage":"_9ecb83c","steps":"_e3cb9d6"};